import type { CandidateVacancy } from '../types';
import { mockCandidateActivitySphere } from './mockCandidateActivitySphere';
import { mockCandidateCity } from './mockCandidateCity';
import { mockCandidateCompany } from './mockCandidateCompany';
import { mockCandidateCurrency } from './mockCandidateCurrency';
import { mockCandidateNamedReference } from './mockCandidateNamedReference';
import { mockCandidatePaymentPeriod } from './mockCandidatePaymentPeriod';
import { mockCandidateTariff } from './mockCandidateTariff';
import { mockCandidateUser } from './mockCandidateUser';
import { mockCandidateVacancyActivity } from './mockCandidateVacancyActivity';

export function mockCandidateVacancy(
  overrides: Partial<CandidateVacancy> = {}
): CandidateVacancy {
  return {
    id: 1,
    name: 'Frontend developer',
    salaryFrom: 4000,
    salaryTo: 6000,
    mandatoryRequirements: 'At least two years of React experience',
    additionalRequirements: 'TypeScript experience is preferred',
    responsibilities: 'Develop and maintain user interfaces',
    requiredCandidatesCount: 2,
    startDate: '2026-08-01',
    status: 'active',
    interviewFinalMessage: 'Thank you for completing the interview',
    ai_sphere_fill: true,
    candidateVacancyMatchPercent: 85,
    candidateVacancyStatus: 'proposed',
    candidateVacancyCreatedAt: '2026-07-01T09:00:00.000Z',
    decisionType: 'POSITIVE',
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-07-10T10:00:00.000Z',
    vacancyActivities: [mockCandidateVacancyActivity()],
    currency: mockCandidateCurrency(),
    company: mockCandidateCompany(),
    cities: [mockCandidateCity()],
    responsibleUser: mockCandidateUser(),
    activitySpheres: [mockCandidateActivitySphere()],
    employmentTypes: [mockCandidateNamedReference()],
    scheduleWorks: [
      mockCandidateNamedReference({
        id: 2,
        name: 'Flexible schedule',
        slug: 'flexible-schedule',
      }),
    ],
    skills: [
      mockCandidateNamedReference({
        id: 3,
        name: 'React',
        slug: 'react',
      }),
    ],
    paymentPeriod: mockCandidatePaymentPeriod(),
    tariffs: [mockCandidateTariff()],
    candidates: ['John Doe'],
    ...overrides,
  };
}
